<ng-container *ngIf="mostrarPublicidadIntersticial && !isMobile">
  <aside class="publicidadIntersticial" aria-label="Publicidad Intersticial">
    <a [href]="publicidadInstertsticial?.enlace">
      <img [src]="publicidadInstertsticial?.img" [alt]="publicidadInstertsticial?.titulo" />
    </a>
    <button mat-button class="btnCerrarInstersticial" (click)="cerrarPublicidadIntersticial()">Cerrar Publicidad ({{ temporizadorCierreIntersticial }})</button>
  </aside>
</ng-container>

<ng-container *ngIf="mostrarPublicidadIntersticialMovil && isMobile">
  <aside class="publicidadIntersticial" aria-label="Publicidad Intersticial Movil">
    <a [href]="publicidadInstertsticialMovil?.enlace">
      <img [src]="publicidadInstertsticialMovil?.img" [alt]="publicidadInstertsticialMovil?.titulo" />
    </a>
    <button mat-button class="btnCerrarInstersticial" (click)="cerrarPublicidadIntersticial()">Cerrar Publicidad ({{ temporizadorCierreIntersticial }})</button>
  </aside>
</ng-container>

<app-header></app-header>

<app-modal-politica-co (reject)="reject()" (accept)="accept($event)" [config]="consents" *ngIf="consentType === 'normal' && (consents.init === false || consents.config === true) && mostrarConsent"></app-modal-politica-co>
<app-cookie-consent-sub *ngIf="consentType === 'sub'"></app-cookie-consent-sub>

<main class="home-contenedor" id="home-contenedor" [ngStyle]="publicidadFondoCompleto?.img && !isMobile ? { 'background-image': 'url(' + publicidadFondoCompleto?.img + ')' } : null" [ngClass]="{ 'fondo-publicidad-full': publicidadFondoCompleto?.img && !isMobile, 'noticias-reels': pageReels }">
  <section class="contenedor-publicidad contenedor-publicidad-sky sky-l">
    <ng-container *ngIf="!isInIframe">
      <div style="min-width: 120px; min-height: 600px" class="publi-lateral publicidad-no-sticky">
        <ng-container *ngIf="publicidadIzquierda?.enlace">
          <a [href]="publicidadIzquierda?.enlace" target="_blank">
            <iframe [src]="publicidadIzquierda?.urlIframe | safeResourceUrl" width="300" height="600" frameborder="0" scrolling="no" *ngIf="publicidadIzquierda?.esIframe == 1" title="Publicidad"></iframe>
            <div *ngIf="publicidadIzquierda?.esIframe == 0">
              <img [src]="publicidadIzquierda?.img" alt="ads" loading="lazy" width="100%" height="100%" *ngIf="publicidadIzquierda?.esVideo == 0" />
              <video style="width: 100%" width="100%" height="100%" autoplay controls [muted]="'muted'" *ngIf="publicidadIzquierda?.esVideo == 1">
                <source [src]="publicidadIzquierda?.img" type="video/mp4" />
              </video>
            </div>
          </a>
        </ng-container>
        <ng-container *ngIf="!publicidadIzquierda?.enlace">
          <div id="SKY_L_SUP" class="publicidad-no-sticky"></div>
          <div id="SKY_L_INF" class="publicidad-no-sticky"></div>
        </ng-container>

        <ng-container *ngIf="publicidadIzquierdaAbajo">
          <a [href]="publicidadIzquierdaAbajo?.enlace" target="_blank">
            <iframe [src]="publicidadIzquierdaAbajo?.urlIframe | safeResourceUrl" width="300" height="600" frameborder="0" scrolling="no" *ngIf="publicidadIzquierdaAbajo?.esIframe == 1" title="Publicidad"></iframe>
            <ng-container *ngIf="publicidadIzquierdaAbajo?.esIframe == 0">
              <img [src]="publicidadIzquierdaAbajo?.img" alt="ads2" loading="lazy" width="100%" height="100%" *ngIf="publicidadIzquierdaAbajo?.esVideo == 0" />
              <video style="width: 100%" width="100%" height="100%" autoplay controls [muted]="'muted'" *ngIf="publicidadIzquierdaAbajo?.esVideo == 1">
                <source [src]="publicidadIzquierdaAbajo?.img" type="video/mp4" />
              </video>
            </ng-container>
          </a>
        </ng-container>
        <ng-container *ngIf="publicidadIzquierdaAbajo?.tag_iframe">
          <iframe title="Publicidad" [src]="publicidadIzquierdaAbajo?.tag_iframe | safeResourceUrl" WIDTH="1" HEIGHT="1" MARGINWIDTH="0" MARGINHEIGHT="0" HSPACE="0" VSPACE="0" FRAMEBORDER="0" SCROLLING="no" BORDERCOLOR="#000000"></iframe>
        </ng-container>
      </div>
    </ng-container>
  </section>

  <section class="center-container">
    <div class="contenedor-publicidad contenedor-publicidad-header" id="HOME-CABECERA-SKIN"></div>
    <section class="contenedor-publicidad contenedor-publicidad-header" id="HOME-CABECERA">
      <div style="margin: 0 auto; width: 100%" *ngIf="!isInIframe">
        <ng-container *ngIf="publicidadCabecera?.enlace">
          <a [href]="publicidadCabecera?.enlace" target="_blank">
            <iframe [src]="publicidadCabecera?.urlIframe | safeResourceUrl" width="{{ publicidadCabecera?.width }}" height="{{ publicidadCabecera?.height }}" frameborder="0" scrolling="no" *ngIf="publicidadCabecera?.esIframe == 1"></iframe>
            <div *ngIf="publicidadCabecera?.esIframe == 0">
              <img [src]="publicidadCabecera?.img" style="width: 100%" alt="ads" loading="lazy" width="100%" height="100%" *ngIf="publicidadCabecera?.esVideo == 0" />
              <video style="width: 100%" width="100%" height="100%" autoplay controls [muted]="'muted'" *ngIf="publicidadCabecera?.esVideo == 1">
                <source [src]="publicidadCabecera?.img" type="video/mp4" />
              </video>
            </div>
          </a>
        </ng-container>
      </div>
    </section>

    <section class="contenedor-noticias" [ngClass]="{ 'fondo-publicidad-full': publicidadFondoCompleto?.img }">
      <router-outlet (activate)="stopTTS()"></router-outlet>
      <ng-container *ngIf="isShow">
        <div class="contenedor-publicidad contenedor-publicidad-footer">
          <div *ngIf="(!isInIframe && publicidadFooter?.enlace) || flotante_footer">
            <button class="close-pub" type="button" (click)="featureHide()">x</button>
            <div id="FLOOR_AD" #publiFLOOR style="min-width: 300px; min-height: 50px"></div>
            <div style="min-width: 300px">
              <a [href]="publicidadFooter?.enlace" target="_blank">
                <iframe [src]="publicidadFooter?.urlIframe | safeResourceUrl" width="980" height="90" frameborder="0" scrolling="no" *ngIf="publicidadFooter?.esIframe == 1"></iframe>
                <div *ngIf="publicidadFooter?.esIframe == 0">
                  <img [src]="publicidadFooter?.img" alt="ads" loading="lazy" width="100%" height="100%" *ngIf="publicidadFooter?.esVideo == 0" />
                  <video style="width: 100%" width="100%" height="100%" autoplay controls [muted]="'muted'" *ngIf="publicidadFooter?.esVideo == 1">
                    <source [src]="publicidadFooter?.img" type="video/mp4" />
                  </video>
                </div>
              </a>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isShow">
        <div class="contenedor-publicidad contenedor-publicidad-footer-movil">
          <div *ngIf="(!isInIframe && publicidadFooterMovil?.enlace) || flotante_footer">
            <button class="close-pub" type="button" (click)="featureHide()">x</button>
            <div id="Floor_Mobile" style="min-width: 300px; min-height: 50px"></div>
            <div style="min-width: 300px">
              <a [href]="publicidadFooterMovil?.enlace" target="_blank">
                <iframe [src]="publicidadFooterMovil?.urlIframe | safeResourceUrl" width="{{ publicidadFooterMovil?.width }}" height="{{ publicidadFooterMovil?.height }}" frameborder="0" scrolling="no" *ngIf="publicidadFooterMovil?.esIframe == 1"></iframe>
                <div *ngIf="publicidadFooterMovil?.esIframe == 0">
                  <img [src]="publicidadFooterMovil?.img" alt="ads" loading="lazy" width="100%" height="100%" *ngIf="publicidadFooterMovil?.esVideo == 0" />
                  <video style="width: 100%" width="100%" height="100%" autoplay controls [muted]="'muted'" *ngIf="publicidadFooterMovil?.esVideo == 1">
                    <source [src]="publicidadFooterMovil?.img" type="video/mp4" />
                  </video>
                </div>
              </a>
            </div>
          </div>
        </div>
      </ng-container>
    </section>
  </section>

  <section class="contenedor-publicidad contenedor-publicidad-sky sky-r">
    <ng-container *ngIf="!isInIframe">
      <div style="min-width: 120px; min-height: 600px" class="publi-lateral publicidad-no-sticky">
        <a [href]="publicidadDerecha?.enlace | safeResourceUrl" target="_blank" *ngIf="publicidadDerecha?.enlace">
          <iframe [src]="publicidadDerecha?.urlIframe | safeResourceUrl" width="300" height="600" frameborder="0" scrolling="no" *ngIf="publicidadDerecha?.esIframe == 1"></iframe>
          <ng-container *ngIf="publicidadDerecha?.esIframe == 0">
            <img [src]="publicidadDerecha?.img" alt="ads" loading="lazy" width="100%" height="100%" *ngIf="publicidadDerecha?.esVideo == 0" />
            <video style="width: 100%" width="100%" height="100%" autoplay controls [muted]="'muted'" *ngIf="publicidadDerecha?.esVideo == 1">
              <source [src]="publicidadDerecha?.img" type="video/mp4" />
            </video>
          </ng-container>
        </a>
        <ng-container *ngIf="!publicidadDerecha?.enlace">
          <div id="SKY_R_SUP" class="publicidad-no-sticky"></div>
          <div id="SKY_R_INF" class="publicidad-no-sticky"></div>
        </ng-container>

        <ng-container *ngIf="publicidadDerechaAbajo">
          <a [href]="publicidadDerechaAbajo?.enlace" target="_blank">
            <iframe [src]="publicidadDerechaAbajo?.urlIframe | safeResourceUrl" width="300" height="600" frameborder="0" scrolling="no" *ngIf="publicidadDerechaAbajo?.esIframe == 1" title="Publicidad"></iframe>
            <ng-container *ngIf="publicidadDerechaAbajo?.esIframe == 0">
              <img [src]="publicidadDerechaAbajo?.img" alt="ads" loading="lazy" width="100%" height="100%" *ngIf="publicidadDerechaAbajo?.esVideo == 0" />
              <video style="width: 100%" width="100%" height="100%" autoplay controls [muted]="'muted'" *ngIf="publicidadDerechaAbajo?.esVideo == 1">
                <source [src]="publicidadDerechaAbajo?.img" type="video/mp4" />
              </video>
              <iframe title="Publicidad" [src]="publicidadDerechaAbajo?.tag_iframe | safeResourceUrl" WIDTH="1" HEIGHT="1" MARGINWIDTH="0" MARGINHEIGHT="0" HSPACE="0" VSPACE="0" FRAMEBORDER="0" SCROLLING="no" BORDERCOLOR="#000000" *ngIf="publicidadDerechaAbajo?.tag_iframe"></iframe>
            </ng-container>
          </a>
        </ng-container>
      </div>
    </ng-container>
  </section>
</main>

<app-footer (cookies)="reconfigureCookies()"></app-footer>
